module.exports = __webpack_public_path__ + "static/socialmedia-ccb1d0f8e21fddf11bf237862281eca1.jpeg";